// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de formation manuelle, technique, technologique et numérique
// https://ifpc-fwb.be/v5/documents/tc/refFMTTN.pdf
// SHA-256 24b87eaf1b99409de31efe631e7c9be85fd93988d88287c1be93775c6dbed02c
// P3: pages 34-37, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "FMTTN-P3-7ae81a4e",
    champ: "",
    section: "SÉCURITÉ",
    kind: "Savoir-faire",
    parent: "Éviter le gaspillage des consommables* et des énergies.",
    text: "Utiliser rationnellement les consommables* et les énergies.",
  },
  {
    id: "FMTTN-P3-4c7225e3",
    champ: "",
    section: "SÉCURITÉ",
    kind: "Savoir-faire",
    parent: "Adopter une posture ergonomique.",
    text: "Appliquer la posture ergonomique recommandée par l’enseignant.",
  },
  {
    id: "FMTTN-P3-f90e8568",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir",
    parent: "Composants organiques",
    text: "Utiliser, en fonction de la tâche à réaliser par les élèves, le vocabulaire spécifique lié aux composants organiques dont substrat, semence, plant, racine, bulbe.",
  },
  {
    id: "FMTTN-P3-496950c3",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir",
    parent: "Outils et techniques* d’horticulture",
    text: "Utiliser, en fonction de la tâche à réaliser par les élèves, le vocabulaire spécifique lié : - aux outils dont semoir, plantoir ; - aux techniques* dont préparer le substrat, semer, planter, étiqueter.",
  },
  {
    id: "FMTTN-P3-32c8b221",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir-faire",
    parent: "Appliquer des techniques* pour effectuer des travaux horticoles de production et d’entretien, en utilisant des outils ou des appareils de mesure adaptés.",
    text: "Appliquer des gestes techniques* horticoles, avec l’aide de l’enseignant, dont préparer le substrat, semer, planter.",
  },
  {
    id: "FMTTN-P3-351cb5b5",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir-faire",
    parent: "Lire un document technique*.",
    text: "Expliquer le mode de mise en œuvre et les conditions de culture, sur la base d’informations techniques* principalement visuelles, fournies avec les semis, le plant.",
  },
  {
    id: "FMTTN-P3-7238861c",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Compétence",
    parent: "Cultiver et entretenir un végétal.",
    text: "Cultiver un végétal, avec l’aide de l’enseignant, selon un mode de culture défini.",
  },
  {
    id: "FMTTN-P3-7a868be1",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir",
    parent: "Cultiver et entretenir un végétal.",
    text: "Associer les risques et les dangers liés à l’environnement de travail*, aux consommables*, aux outils, aux ustensiles, aux machines et aux techniques*.",
  },
  {
    id: "FMTTN-P3-03ab9711",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir",
    parent: "Dangers et risques",
    text: "Énoncer les équipements de protection requis, en lien avec l’environnement de travail*, les consommables*, les outils, les ustensiles, les machines et les techniques*.",
  },
  {
    id: "FMTTN-P3-79f57022",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir-faire",
    parent: "Préparer le poste de travail*, le matériel* et les consommables* nécessaires à une tâche.",
    text: "Choisir le matériel* et les consommables* parmi ce qui est mis à disposition. Prélever et disposer les matériaux* préparés par l’enseignant.",
  },
  {
    id: "FMTTN-P3-4d08deeb",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir-faire",
    parent: "Gérer l’espace de travail.",
    text: "Maintenir l’espace de travail propre et rangé, avec l’aide de l’enseignant.",
  },
  {
    id: "FMTTN-P3-592422f3",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Savoir-faire",
    parent: "Valoriser les déchets produits lors d’une tâche.",
    text: "Trier, avec l’aide de l’enseignant, dans leur cadre de production, les déchets recyclables, compostables, récupérables.",
  },
  {
    id: "FMTTN-P3-6678ffd1",
    champ: "",
    section: "TECHNIQUES DE CULTURE",
    kind: "Compétence",
    parent: "Valoriser les déchets produits lors d’une tâche.",
    text: "Adopter, avec l’aide de l’enseignant, une attitude proactive qui prend en considération les risques et les dangers, pour soi et pour les autres, lors de la préparation du poste de travail* et de l’exécution des gestes techniques*, en recourant notamment aux équipements de protection adéquats.",
  },
  {
    id: "FMTTN-P3-6f11a9ad",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "",
    kind: "Savoir",
    parent: "Vocabulaire spécifique au software*.",
    text: "Utiliser, adéquatement en contexte, les termes dont moteur de recherche, barre de recherche, navigateur.",
  },
  {
    id: "FMTTN-P3-1af0f1a3",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "",
    kind: "Savoir",
    parent: "Vocabulaire spécifique au software*.",
    text: "Utiliser, adéquatement en contexte, le terme Internet*.",
  },
  {
    id: "FMTTN-P3-ee274790",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "",
    kind: "Savoir-faire",
    parent: "Déterminer des mots-clés/des combinaisons de mots/ des opérateurs adéquats pour effectuer une recherche.",
    text: "Sélectionner un ou plusieurs mot(s)-clé(s) pertinent(s) pour effectuer une recherche.",
  },
  {
    id: "FMTTN-P3-54d6cb38",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "",
    kind: "Savoir-faire",
    parent: "Utiliser un outil de recherche* en s’adaptant à l’environnement spécifique d’utilisation : logiciel*, système d’exploitation*, Web…",
    text: "Utiliser un outil de recherche* en suivant les directives de l’enseignant.",
  },
  {
    id: "FMTTN-P3-ceed8e27",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "",
    kind: "Savoir-faire",
    parent: "Enregistrer/exporter un document.",
    text: "Enregistrer un document localement.",
  },
  {
    id: "FMTTN-P3-798c1990",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "",
    kind: "Compétence",
    parent: "Enregistrer/exporter un document.",
    text: "Rechercher une information au moyen d’un outil de recherche* imposé, en utilisant une bibliothèque appropriée (images, vidéos…) et des mots-clés choisis collectivement.",
  },
  {
    id: "FMTTN-P3-14505413",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "CRÉATION DE CONTENUS",
    kind: "Savoir",
    parent: "Outils de production, de collaboration, de partage et d’interaction",
    text: "Identifier les boutons donnant accès à la prise de son et d’image, à l’insertion de texte, à l’enregistrement de fichier.",
  },
  {
    id: "FMTTN-P3-7071c454",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "CRÉATION DE CONTENUS",
    kind: "Savoir-faire",
    parent: "Outils de production, de collaboration, de partage et d’interaction",
    text: "Utiliser les fonctions principales d’un outil, d’une application*, d’un logiciel* choisi par l’enseignant.",
  },
  {
    id: "FMTTN-P3-3d80e553",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "CRÉATION DE CONTENUS",
    kind: "Savoir-faire",
    parent: "Traiter une image fixe.",
    text: "Traiter une image (ex. : rogner, redimensionner, appliquer un effet, modifier la luminosité, le contraste).",
  },
  {
    id: "FMTTN-P3-4bfed106",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "CRÉATION DE CONTENUS",
    kind: "Savoir-faire",
    parent: "Respecter les droits de propriété.",
    text: "Utiliser un contenu médiatique, en respectant les droits de propriété de la personne physique ou morale à qui appartient l’image.",
  },
  {
    id: "FMTTN-P3-95ce7302",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "CRÉATION DE CONTENUS",
    kind: "Savoir-faire",
    parent: "Respecter les droits à l’image et à la voix.",
    text: "Expliquer le principe de droit à l’image lié au consentement de la personne prise en photo.",
  },
  {
    id: "FMTTN-P3-ecd207fc",
    champ: "VOLET 2 : NUMÉRIQUE",
    section: "CRÉATION DE CONTENUS",
    kind: "Compétence",
    parent: "Produire et traiter des contenus multimédias.",
    text: "Produire un contenu médiatique simple (ex. : son, image, photo, vidéo, texte).",
  },
];
